/**
 * Created by Mark on 18/12/2016.
 */

import ApplicationServices from './base-service.js';
import Constants from '../constants.js';
import Action    from '../application-actions.js';


class  ReportsServices {


    getExamDetailed(moduleID , classID , set , due , language , studentID){
        return ApplicationServices.call(Constants.GET_EXAM_DETAILED , {studentID:studentID  , moduleID:moduleID , classID:classID , to:due , language:language , from:set} ).then(function(response){
            return response;
        });
    }

    getSentenceBuildingDetailed(moduleID , classID , set , due , language , catalog , studentID){
        return ApplicationServices.call(Constants.GET_BUILDING_DETAILED , {studentID:studentID , moduleID:moduleID , classID:classID , to:due , language:language , from:set , catalog:catalog} ).then(function(response){
            return response;
        });
    }

    getClassesHighscore(from , to){
        return ApplicationServices.call(Constants.GET_CLASSES_HIGHSCORE , {to:to , from:from}).then(function(response){
            Action.update(Constants.GET_CLASSES_HIGHSCORE , response.list);
            return response.success
        })
    }

    getClassesStudentsHighscore(classID , from , to){
        return ApplicationServices.call(Constants.GET_CLASSES_STUDENTS_HIGHSCORE , {to:to , from:from , class_uid:classID}).then(function(response){
            Action.update(Constants.GET_CLASSES_STUDENTS_HIGHSCORE , response.list);
            return response.success
        })
    }

    getAccountStudentsHighscore(classID , from , to){
        return ApplicationServices.call(Constants.GET_ACCOUNT_STUDENTS_HIGHSCORE , {to:to , from:from , class_uid:classID}).then(function(response){
            Action.update(Constants.GET_ACCOUNT_STUDENTS_HIGHSCORE , response.list);
            return response.list
        })
    }

    getLanguageCourse(screenUid , language , set , due , classID , studentID){
        return ApplicationServices.call(Constants.GET_CLASS_LANGUAGE_COURSE , 
            {studentID:studentID , classID:classID , to:due , language:language , from:set , screenUid:screenUid} ).then(function(response){
            return response;
        });
    }

    getLanguageCourseDetail(moduleID , classID , studentID , language , set , due ){
        return ApplicationServices.call(Constants.GET_CLASS_LANGUAGE_COURSE_DETAIL , 
                {from:set , to:due , ietf:language , studentID:studentID , classID:classID , moduleID:moduleID} ).then(function(response){
            return response;
        });
    }

    getExamCourseComplete(screenUid , language , set , due , classID , studentID)
    {
        return ApplicationServices.call(Constants.GET_EXAM_COURSE , {studentID:studentID , screenUid:screenUid , classID:classID , to:due , language:language , from:set} ).then(function(response){
            return response;
        });
    }

    getSentence(screenUID , language , set , due , classID , studentID)
    {
        return ApplicationServices.call(Constants.GET_SENTENCE_COURSE , {studentID:studentID , classID:classID , to:due , language:language , from:set , screenUID:screenUID} ).then(function(response){
            return response;
        });
    }

    getVerb(verbUID , language , set , due , classID , studentID)
    {
        return ApplicationServices.call(Constants.GET_VERBS_COURSE , {studentID:studentID , classID:classID , to:due , language:language , from:set , verbUid:verbUID} ).then(function(response){
            return response;
        });
    }

    getGrammar(screenUID , language , set , due , classID , studentID)
    {
        return ApplicationServices.call(Constants.GET_GRAMMAR_COURSE , {studentID:studentID , classID:classID , to:due , language:language , from:set , screenUID:screenUID, toIetf:language} ).then(function(response){
            return response;
        });
    }

    getVerbsDetailed(moduleID , classID , set , due , language, studentID){
        return ApplicationServices.call(Constants.GET_VERBS_DETAILED , {studentID:studentID , moduleID:moduleID , classID:classID , to:due , language:language , from:set} ).then(function(response){
            return response;
        });
    }


}

export default new ReportsServices();